import { IEventDataSource } from "@/types/interfaces";
import { BigBashEvent, GameOrderSnapshot } from "@/types/types";
import { IntervalPoller, OnPollingStarted, OnPollingStopped } from "@infrastructure/IntervalPoller";

export class GameOrderPoller {
	private readonly intervalPoller: IntervalPoller<BigBashEvent, GameOrderSnapshot>;

	constructor(
		onPollingStarted: OnPollingStarted,
		onPollingStopped: OnPollingStopped<BigBashEvent>,
		event: BigBashEvent,
		eventDataSource: IEventDataSource
	) {
		this.intervalPoller = new IntervalPoller<BigBashEvent, GameOrderSnapshot>(
			(currentEvent: BigBashEvent): Promise<GameOrderSnapshot> => eventDataSource.getGameOrder(currentEvent.id),
			(currentEvent: BigBashEvent, gameOrderSnapshot: GameOrderSnapshot): BigBashEvent =>
				({ ...currentEvent, game_order: gameOrderSnapshot.game_order, games: gameOrderSnapshot.games }),
			onPollingStarted,
			onPollingStopped,
			event,
			'game order'
		);
	}

	invalidateInFlightPollRequestAndResetSchedule(): void {
		this.intervalPoller.invalidateInFlightPollRequestAndResetSchedule();
	}

	setEvent(event: BigBashEvent): void {
		this.intervalPoller.setState(event);
	}

	start(): void {
		this.intervalPoller.start();
	}

	stop(): void {
		this.intervalPoller.stop();
	}

	resetSchedule(): void {
		this.intervalPoller.resetSchedule();
	}
}
